module.exports = [
  {
    name: {
      zh: '黃竹君',
      en: 'FANNY VONG',
    },
    title: {
      zh: '院長',
      en: 'President',
    },
    description: {
      zh: '黃竹君博士於2001年獲任命為旅遊學院院長。她擁有由葡萄牙Instituto Superior de Ciências do Trabalho e da Empresa (ISCTE)（現稱葡萄牙里斯本工商管理大學）商業組織及管理博士學位，並就旅遊業發展等議題發表了逾50篇研究論文及文章。',
      en: 'Dr. Vong has been in charge of IFT since 2001. She holds a Ph.D. in Business Organisation and Management, awarded by the ISCTE - Instituto Superior de Ciências do Trabalho e da Empresa (now known as University Institute of Lisbon), in Portugal. Dr. Vong is the author of more than 50 research papers and published articles on tourism development and related topics.',
    },
    image: '/images/management-teams/member-01.jpg',
  },
  {
    name: {
      zh: '甄美娟',
      en: 'FLORENCE IAN',
    },
    title: {
      zh: '副院長',
      en: 'Vice President',
    },
    description: {
      zh: '甄美娟女士負責管理旅遊學院的行政及培訓單位。她於英國布里斯托大學取得教育管理碩士學位。加入學院前，曾於澳門一間頂尖的酒店任職。',
      en: 'Ms. Ian supervises the administrative work and training arms of IFT. She holds a Master’s Degree in Education Management, earned at the University of Bristol, in Britain. Ms. Ian’s experience includes working for a leading hotel in Macao.',
    },
    image: '/images/management-teams/member-02.jpg',
  },
  {
    name: {
      zh: '呂劍英',
      en: 'CONNIE LOI',
    },
    title: {
      zh: '旅遊高等學校代副校長<br/>酒店管理和旅遊會展及節目管理課程主任',
      en: 'Acting Vice Director of the Tourism College, Coordinator for Hotel Management, Tourism Event Management',
    },
    description: {
      zh: '副教授呂劍英博士是旅遊學院校友，2001年於學院獲得旅遊企業管理學士學位及酒店管理高級文憑。隨後，她成功取得澳洲詹姆士庫克大學哲學博士學位。呂劍英博士的研究領域包括酒店客人滿意度、目的地營銷、旅客行為和旅遊產品管理等，其著作經常出現在各大國際學術期刊及研討會論文集中。',
      en: 'Dr. Loi’s career has brought her full circle. Dr. Loi studied Tourism Business Management at IFT and graduated in 2001. She also earned a Higher Diploma in Hotel Management from the Institute. She subsequently received a Ph.D. in Tourism from James Cook University in Australia. Her current research interests include hotel guest satisfaction, destination marketing, tourist behaviour and tourism product management. Results of her research appear frequently in international academic journals and in conference proceedings in the field of tourism and hospitality.',
    },
    image: '/images/management-teams/member-03.jpg',
    textLength: 200,
  },
  {
    name: {
      zh: '羅天蘭',
      en: 'DIAMANTINA COIMBRA',
    },
    title: {
      zh: '旅業及酒店業學校校長',
      en: 'Director of the Tourism and Hotel School',
    },
    description: {
      zh: '羅天蘭女士於1992年至2000年期間，出任望廈迎賓館館長，並於2001年獲任命為旅業及酒店業學校校長。她擁有教育管理碩士學位及學士後教育文憑。',
      en: 'Mrs. Coimbra was appointed Director of the Tourism and Hotel School in 2001 after a stint as Director of the Pousada de Mong-Há from 1992 to 2000. Mrs. Coimbra holds a Master’s Degree in Education Management and a Postgraduate Diploma in Education Policy.',
    },
    image: '/images/management-teams/member-04.jpg',
  },
  {
    name: {
      zh: '朱振榮',
      en: 'ANTÓNIO CHU',
    },
    title: {
      zh: '技術暨學術輔助部處長',
      en: 'Head of the Technical and Academic Support Division',
    },
    description: {
      zh: '朱振榮先生自學院1995年成立之初便加入了團隊，曾任教職。於2000年起獲委任為技術暨學術輔助部處長。他擁有旅遊經濟管理學士學位，有在澳門酒店和銀行業的工作經驗，曾出任澳門特區第四屆行政長官選舉委員會委員及第十三屆澳區全國人大代表選舉會議成員。',
      en: 'Mr. Chu joined the Institute when it was founded in 1995. He has held several positions at the Institute - including teaching positions. He was appointed Head of the Technical and Academic Support Division in 2000. His previous experience includes working in the hotel and banking industries in Macao. He was a member of the fourth electoral committee appointed to elect the Macao Chief Executive and of the conference that elected deputies to represent the Macao SAR at the 13<sup>th</sup> National People’s Congress. Mr. Chu holds a Bachelor’s Degree in Tourism Management and Economics.',
    },
    image: '/images/management-teams/member-05.jpg',
    textLength: 350,
  },
  {
    name: {
      zh: '陳美霞',
      en: 'CHAN MEI HA',
    },
    title: {
      zh: '行政暨財政輔助部處長',
      en: 'Head of the Administrative and Financial Support Division',
    },
    description: {
      zh: '陳美霞女士自1998年起獲委任為行政暨財政輔助部處長。在1996年加入學院前，曾分別於公私營企業工作，擁有與船務運輸、博娛樂及公共財政相關的工作經驗。她擁有公共行政學士學位。',
      en: 'Ms. Chan was appointed Head of the Administrative and Financial Support Division in 1998. She joined the Institute in 1996 after gaining experience in the public and private sectors, including stints in the fields of transport, gaming entertainment and public finance. She holds a Bachelor’s Degree in Public Administration.',
    },
    image: '/images/management-teams/member-06.jpg',
  },
  {
    name: {
      zh: '羅嘉賢',
      en: 'HELENA LO',
    },
    title: {
      zh: '望廈迎賓館館長',
      en: 'Director of the Pousada de Mong-Há',
    },
    description: {
      zh: '旅遊學院校友羅嘉賢博士於2003年加入學院教學酒店 ― 望廈迎賓館，並於2012年起擔任望廈迎賓館館長一職。她擁有工商管理博士學位，並於2015年獲亞太旅遊協會（PATA）頒發“PATA Face of the Future”獎項，該殊榮表揚旅遊業界的年輕人才。',
      en: 'Dr. Lo is an IFT alumna. She joined the staff of the Pousada de Mong-Há, the educational hotel of IFT, in 2003 and rose to head of the establishment in 2012. She holds a Ph.D. in Business Administration; and received the PATA Face of the Future Award in 2015, an award for enterprising young people working in tourism.',
    },
    image: '/images/management-teams/member-07.jpg',
  },
  {
    name: {
      zh: '黃育山',
      en: 'DAVID WONG',
    },
    title: {
      zh: '餐飲範疇職務主管',
      en: 'Head of the Food and Beverage Department',
    },
    description: {
      zh: '黃育山先生負責管理旅遊學院教學餐廳及位於“南灣‧雅文湖畔”的旅遊學院咖啡廊的運作，並教授餐飲和酒類課程。他擁有英國伯明翰大學酒店管理碩士學位。',
      en: 'Mr. Wong supervises the IFT Educational Restaurant on the Mong-Há Campus and the IFT Café on the Nam Van Lake waterfront, and teaches courses on food and wine. Mr. Wong holds a Master’s Degree in Hospitality Management from Britain’s University of Birmingham.',
    },
    image: '/images/management-teams/member-08.jpg',
  },
]
